/* eslint-disable @typescript-eslint/camelcase */
import { useStaticQuery, graphql } from 'gatsby';
import { TaxonomyNode } from '~/@types/taxonomy';
import { taxonomyNodeToFilterOption } from './FilterOptionsHelpers';

interface TaxonomyYear {
    kontentTaxonomy: TaxonomyNode;
}

const TaxonomyArticlesTypeData = () => {
    const data: TaxonomyYear = useStaticQuery(graphql`
        {
            kontentTaxonomy(system: { codename: { eq: "year" } }) {
                terms {
                    name
                }
                system {
                    codename
                }
            }
        }
    `);

    const taxonomyNode = data.kontentTaxonomy;

    return taxonomyNodeToFilterOption(taxonomyNode);
};

export default TaxonomyArticlesTypeData;
